<template>
  <div>
    <label class="flex items-center cursor-pointer">
      <div
        :class="[
          'aspect-square relative flex items-center justify-center w-5 h-5 border-[2px] border-border-divider rounded-[4px] mr-2',
          props.checked ? 'bg-transparent border-transparent' : 'bg-white',
          ,
        ]"
      >
        <svg
          v-if="props.checked"
          class="absolute left-[-2px] top-[-2px] w-5 h-5 pointer-events-none outline-none"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 0.5C19.6406 0.5 21 1.85938 21 3.5V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V3.5C0 1.85938 1.3125 0.5 3 0.5H18ZM15.8906 8.9375C16.4062 8.42188 16.4062 7.625 15.8906 7.10938C15.375 6.59375 14.5781 6.59375 14.0625 7.10938L9 12.1719L6.89062 10.1094C6.375 9.59375 5.57812 9.59375 5.0625 10.1094C4.54688 10.625 4.54688 11.4219 5.0625 11.9375L8.0625 14.9375C8.57812 15.4531 9.375 15.4531 9.89062 14.9375L15.8906 8.9375Z"
            fill="black"
          />
        </svg>
        <input
          type="checkbox"
          class="hidden"
          :checked="props.checked"
          @change="() => emits('changes')"
        />
      </div>
      <div class="font-normal">{{ props.title }}</div>
    </label>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  title: string
  checked: boolean
}>()

const emits = defineEmits<{
  (e: 'changes'): () => void
}>()
</script>
